import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CardProductContainer from 'containers/CardProductContainer/CardProductContainer';
import ExpandableList from 'components/ExpandableList';
import { buildProductListStructuredData } from 'utils/StructuredData';
import classes from './PackageTabA.module.scss';

const {
  string,
  arrayOf,
  array,
  number,
  shape,
} = PropTypes;

const PackageTabA = (props) => {
  const {
    items = [],
    selectedIndex,
  } = props;

  const locations = {
    top: 'Top',
    left: 'Left',
    right: 'Right',
    bottom: 'Bottom',
  };

  function renderContentSection(copy, colClasses, expandableItems) {
    return (
      (copy || expandableItems.length > 0) &&
        <div className={colClasses}>
          <div className='k-col'>
            {copy &&
              <div
                className={classes.contentContainer}
                dangerouslySetInnerHTML={{ __html: copy }}
              />}
            {expandableItems.length > 0
              ? <ExpandableList type='ExpandableListItemA' renderStructuredData={false} items={expandableItems} /> : ''}
          </div>
        </div>
    );
  }

  function renderTab(item, i) {
    const {
      topCopy,
      leftCopy,
      rightCopy,
      bottomCopy,
      heading,
      description,
      image,
      products = [],
      expandableItems = [],
      expandableItemsLocation,
    } = item;

    const structuredData = buildProductListStructuredData(products);

    const {
      imageURI,
      imageAltText,
    } = image || {};

    const imageElement = imageURI && (
      <img
        className={classes.image}
        src={imageURI}
        alt={imageAltText}
        width={400}
        height={260}
        loading='lazy'
        aria-hidden
      />
    );

    return (
      <div className={classNames('k-tab', { 'k-tab-active': selectedIndex === i })} key={i}>
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{ __html: structuredData }}
          style={{ display: 'none' }} // Adding here since the k-tab-active class will make it visible otherwise
        />
        <div className={classNames(classes.container, 'container Container__wrapper')}>
          {(topCopy || heading || description || products || locations.top === expandableItemsLocation) &&
            <div className='row'>
              {
                renderContentSection(
                  topCopy,
                  'mb-3 mb-md-0 col-md', locations.top === expandableItemsLocation ? expandableItems : [],
                )
              }
              {(heading || description || products) &&
              <div className='col-md'>
                <div className='k-col'>
                  {(heading || description || imageElement) &&
                    <div className={classes.contentContainer}>
                      {imageElement &&
                        <div className={classes.imageContainer}>
                          {imageElement}
                        </div>}
                      {heading &&
                        <h3
                          dangerouslySetInnerHTML={{ __html: heading }}
                        />}
                      {description &&
                        <div
                          dangerouslySetInnerHTML={{ __html: description }}
                        />}
                    </div>}
                  {products &&
                    <div className={classes.contentContainer}>
                      <CardProductContainer items={products} itemType='CardProductDItem' />
                    </div>}
                </div>
              </div>}
            </div>}
          {(leftCopy || locations.left === expandableItemsLocation
            || rightCopy || locations.right === expandableItemsLocation) &&
            <div className='row'>
              {
                renderContentSection(
                  leftCopy,
                  'mb-3 mb-md-0 col-md',
                  locations.left === expandableItemsLocation ? expandableItems : [],
                )
              }
              {
                renderContentSection(
                  rightCopy,
                  'col-md',
                  locations.right === expandableItemsLocation ? expandableItems : [],
                )
              }
            </div>}
          {(bottomCopy || locations.bottom === expandableItemsLocation) &&
            <div className='row'>
              {
                renderContentSection(
                  bottomCopy,
                  'col-md',
                  locations.bottom === expandableItemsLocation ? expandableItems : [],
                )
              }
            </div>}
        </div>
      </div>
    );
  }

  return items.map(renderTab);
};

const PackageTabT = shape({
  title: string,
  heading: string,
  description: string,
  topCopy: string,
  rightCopy: string,
  leftCopy: string,
  bottomCopy: string,
  image: shape({
    imageURI: string,
    imageAltText: string,
  }),
  products: array,
  expandableItems: array,
  expandableItemsLocation: string,
});

PackageTabA.propTypes = {
  /**
   * Package tab content
   */
  items: arrayOf(PackageTabT),
  /**
   * Index of selected tab to determine whether or not it should display
   */
  selectedIndex: number,
};

export default PackageTabA;
